import { z } from 'zod';
const NewsletterValidationSchema = z.object({
    Email: z.string().email()
});
// Lenient schema for inbound Intercom webhooks: validates only consumed fields and allows unknown keys.
const IntercomWebhookSchema = z.object({
    topic: z.string(),
    id: z.string().optional(),
    delivery_attempts: z.number().optional(),
    data: z
        .object({
        item: z
            .object({
            id: z.string().optional(),
            external_id: z.string().nullish()
        })
            .optional()
    })
        .optional()
});
const CONTACT_SUBJECTS = [
    'General inquiry',
    'Media inquiry',
    'Partnership',
    'Technical support',
    'Feedback',
    'Other'
];
const ContactFormValidationSchema = z.object({
    name: z.string().trim().min(1).max(100),
    email: z.string().trim().email(),
    organization: z.string().trim().max(200).optional(),
    subject: z.enum(CONTACT_SUBJECTS),
    message: z.string().trim().min(1).max(5000)
});
export { CONTACT_SUBJECTS, ContactFormValidationSchema, IntercomWebhookSchema, NewsletterValidationSchema };
//# sourceMappingURL=services.js.map